import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { StaffAction } from '../../actions/staff.action';
import { StaffEditPage } from '../staff/edit/staff-edit';
import { AbstractPage } from '../_com/abstract-page';
import { AuthStore } from '../../stores/auth-store';

/**
 * Generated class for the ProfilePage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html',
})
export class ProfilePage extends AbstractPage{

  constructor(
  	public navCtrl: NavController, 
  	public navParams: NavParams,
    private staffAction:StaffAction,
    private authStore:AuthStore,
  	) {
  	super();
  }

  data = {}

  ionViewDidLoad() {
    this.refresh();
  }


  /**
   * リフレッシュ
   */
  refresh(){
  	var loginId = this.authStore.getLogin()["id"];
    this.staffAction.getOne({id:loginId}).subscribe((data)=>{
      this.data = data.data.User;
    })
  }

  /**
   * 編集処理
   */
  edit(){

    this.navCtrl.push(StaffEditPage, this.data);

    // var self = this;
    // let modal = this.modalController.create(StaffEditPage, this.data);
    // modal.present();
    // modal.onDidDismiss((data)=>{
    //   if(data["update"]){
    //     self.refresh();
    //   }
    // });
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts